import { useMutation } from '@tanstack/react-query';
import { patchComponent } from 'api/resources/component';

export const usePatchComponent = () => {
	return useMutation(patchComponent);
};
